import { render, staticRenderFns } from "./mInformation.vue?vue&type=template&id=b439e348&scoped=true&"
import script from "./mInformation.vue?vue&type=script&lang=js&"
export * from "./mInformation.vue?vue&type=script&lang=js&"
import style0 from "./mInformation.vue?vue&type=style&index=0&id=b439e348&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b439e348",
  null
  
)

export default component.exports